import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/data/site";

export default function Contact() {
  return (
    <section
      id="contact"
      className="relative bg-[var(--pam-forest)] text-white"
      style={{ padding: "5% 0" }}
      data-testid="contact-section"
    >
      <div className="container-pam max-w-4xl mx-auto text-center">
        <p className="overline text-[var(--pam-gold)]">Come find us</p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
        >
          The hills are
          <span className="italic text-[var(--pam-gold)]"> waiting.</span>
        </motion.h2>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-6">
          <ContactCard
            icon={<Phone className="w-5 h-5" />}
            label="Phone"
            testId="contact-phone"
            href={`tel:+${SITE.phoneE164}`}
            value={SITE.phoneDisplay}
          />
          <ContactCard
            icon={<Mail className="w-5 h-5" />}
            label="Email"
            testId="contact-email"
            href={`mailto:${SITE.email}`}
            value={SITE.email}
          />
          <ContactCard
            icon={<MapPin className="w-5 h-5" />}
            label="Address"
            testId="contact-address"
            value={SITE.address}
          />
        </div>
      </div>
    </section>
  );
}

function ContactCard({ icon, label, value, href, testId }) {
  const Wrapper = href ? "a" : "div";
  return (
    <Wrapper
      href={href}
      className="block rounded-2xl bg-white/[0.04] border border-white/10 backdrop-blur-md p-6 hover:border-[var(--pam-gold)]/50 transition-colors"
      data-testid={testId}
    >
      <div className="w-11 h-11 rounded-full border border-[var(--pam-gold)]/40 grid place-items-center text-[var(--pam-gold)] mx-auto">
        {icon}
      </div>
      <div className="mt-4 text-[10px] uppercase tracking-[0.3em] text-white/50">
        {label}
      </div>
      <div className="mt-2 text-sm sm:text-base font-light text-white/90 break-words">
        {value}
      </div>
    </Wrapper>
  );
}
